<template>
  <main class="journey-hub bg-[#f5f7f4]">
    <section class="relative sectionContainer isolate overflow-hidden bg-[#063c3f] text-white">
      <div class="hub-pattern absolute inset-0 opacity-25"></div>
      <div class="absolute -right-24 -top-32 h-96 w-96 rounded-full bg-amber-300/20 blur-3xl"></div>
      <div class="relative mx-auto max-w-screen-xl px-4 pb-16 pt-7 sm:px-6 md:pb-20 lg:px-10">
        <JourneyPageLinks current="hub" variant="breadcrumb" dark />
        <div class="mt-14 max-w-3xl">
          <span class="inline-flex items-center gap-2 rounded-full border border-amber-300/30 bg-amber-300/10 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.17em] text-amber-200"><font-awesome-icon icon="fa-solid fa-compass" /> {{ content.hubEyebrow }}</span>
          <h1 class="mt-5 text-4xl font-black tracking-tight text-white md:text-6xl">{{ content.hubTitle }}</h1>
          <p class="mt-5 max-w-2xl text-sm leading-7 text-white/70 md:text-lg md:leading-8">{{ content.hubDescription }}</p>
        </div>

        <section class="mt-10 max-w-5xl rounded-3xl border border-white/15 bg-white/10 p-8  backdrop-blur-sm md:p-7" aria-labelledby="journey-digital-heading">
          <div class="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div class="max-w-3xl">
              <span class="text-xs font-extrabold uppercase tracking-[.16em] text-amber-200">{{ content.digitalEyebrow }}</span>
              <h2 id="journey-digital-heading" class="mt-2 text-2xl font-black leading-tight text-white md:text-3xl">{{ content.digitalTitle }}</h2>
              <p class="mt-3 text-sm leading-7 text-white/75 md:text-base">{{ content.digitalDescription }}</p>
            </div>
            <a href="https://reservation.inanctur.com/" target="_blank" rel="noopener" class="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-amber-300 px-5 py-3 text-sm font-extrabold text-[#063c3f] transition hover:bg-amber-200">
              <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" /> {{ content.digitalCta }}
            </a>
          </div>
          <ul class="mt-6 grid list-none gap-3 p-0 sm:grid-cols-2 lg:grid-cols-4">
            <li v-for="item in content.digitalItems" :key="item" class="flex items-start gap-2 rounded-2xl border border-white/10 bg-black/10 p-3 text-xs leading-5 text-white/85">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="mt-0.5 text-amber-200" /> <span>{{ item }}</span>
            </li>
          </ul>
        </section>
      </div>
    </section>
    <JourneyPageLinks current="hub" />
  </main>
</template>

<script setup>
import { journeyNavigationContent } from '~/data/journey-pages'
import JourneyPageLinks from '~/components/page/JourneyPageLinks.vue'

const { locale } = useI18n()
const language = computed(() => locale.value === 'en' ? 'en' : 'tr')
const content = computed(() => journeyNavigationContent[language.value])

useHead(() => ({
  title: language.value === 'en' ? 'Umrah Journey Centre | İnanç Tour' : 'Umre Yolculuk Merkezi | İnanç Tur',
  meta: [{ name: 'description', content: content.value.hubDescription }]
}))
</script>

<style scoped>
.journey-hub section.sectionContainer { margin: 0; padding-top: 0; padding-bottom: 0; }
.journey-hub p { margin-bottom: 0; }
.journey-hub h1 { margin: 0; line-height: 1.06; }
.journey-hub h2 { margin-bottom: 0; }
.hub-pattern { background-image: radial-gradient(circle at 1px 1px, rgba(255,255,255,.22) 1px, transparent 0); background-size: 27px 27px; mask-image: linear-gradient(to right, black, transparent 82%); }
</style>
